// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar-d1v1M","sidebarOverlay":"sidebarOverlay-TlCLA","sidebarMenu":"sidebarMenu-_G2P7","sidebarMenuGroup":"sidebarMenuGroup-fb0zU"};